import React from 'react'
import {FormattedDate} from 'react-intl'
import {useSelector} from 'react-redux'
import styled from '@emotion/styled'
import {getIsMultiRoomBundlesSearch} from 'modules/search/selectors'

import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

const Separator = styled.span`
  color: ${cssTheme.colors.content.neutral.secondary};
  padding: 0 ${cssTheme.layout.spacing.s200};
`

const RoomsElementText = styled.span`
  padding: ${cssTheme.layout.spacing.s100};
`

type Props = {
  checkIn: string
  checkOut: string
  numberOfGuests: number
  numberOfRooms: number
}

/**
 * Dates and total guest count, e.g. "Dec 17 - Dec 18 · 6 guests, 2 rooms".
 * Multi-room bundle searches omit the room count.
 */
export const RoomsSectionSearchContextGuestCount = ({
  checkIn,
  checkOut,
  numberOfGuests,
  numberOfRooms
}: Props) => {
  const isMultiRoomBundlesSearch = useSelector(getIsMultiRoomBundlesSearch)

  return (
    <>
      <Text variant="labelS" colorPath="content.neutral.secondary" tag="span">
        <FormattedDate
          value={checkIn}
          day="numeric"
          month="short"
          timeZone="UTC"
        />
      </Text>
      <Separator>-</Separator>
      <Text variant="labelS" colorPath="content.neutral.secondary" tag="span">
        <FormattedDate
          value={checkOut}
          day="numeric"
          month="short"
          timeZone="UTC"
        />
      </Text>
      <Separator>·</Separator>
      <Text variant="labelS" tag="span" colorPath="content.neutral.secondary">
        <FormattedMessageWrapper
          id="numberOfGuests"
          defaultMessage="{count, plural, one {1 guest} other {# guests}}"
          values={{
            count: numberOfGuests
          }}
        />

        {!isMultiRoomBundlesSearch && (
          <>
            <span>,</span>
            <RoomsElementText>
              <FormattedMessageWrapper
                id="numberOfRooms"
                defaultMessage="{count, plural, one {1 room} other {# rooms}}"
                values={{
                  count: numberOfRooms
                }}
              />
            </RoomsElementText>
          </>
        )}
      </Text>
    </>
  )
}
